var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    { class: [_vm.sizeClass, { portrait: _vm.isPortrait }] },
    [
      _vm.cropped
        ? _c(
            "div",
            {
              class: ["avatar", { rounded: _vm.isRounded }],
              style: "background-image: url(" + _vm.avatar + ")",
            },
            [_c("img", { attrs: { src: _vm.avatar, alt: _vm.alt } })]
          )
        : _c("img", { attrs: { src: _vm.avatar, alt: _vm.alt } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }